export const createGeneralTourSteps = (that) => {
    const steps = [
        {
            target: '[data-v-step="1"]',
            header: {
                title: `${that.$t("tour.stats")}`,
            },
            content: `${that.$t("tour.statsPanel")}`,
            params: {
                placement: "right",
            },
        },
        {
            target: '[data-v-step="2"]',
            header: {
                title: `${that.$t("tour.sidebarMenu")}`,
            },
            content: `${that.$t("tour.sidebarMenuContent")}`,
            params: {
                placement: "right",
            },
        },
        {
            target: '[data-v-step="3"]',
            header: {
                title: `${that.$t("tour.representativePrivateMessage")}`,
            },
            content: `${that.$t("tour.representativePrivateMessageContent")}`,
            params: {
                placement: "right",
            },
        },
        {
            target: '[data-v-step="4"]',
            header: {
                title: `${that.$t("tour.helpMenu")}`,
            },
            content: `${that.$t("tour.helpMenuContent")}`,
            params: {
                placement: "right",
            },
        },
        {
            target: '[data-v-step="5"]',
            header: {
                title: `${that.$t("tour.settingsMenu")}`,
            },
            content: `${that.$t("tour.settingsMenuContent")}`,
            params: {
                placement: "right",
            },
        },
        {
            target: '[data-v-step="6"]',
            header: {
                title: `${that.$t("tour.profileMenu")}`,
            },
            content: `${that.$t("tour.profileMenuContent")}`,
            params: {
                placement: "right",
            },
        },

        {
            target: '[data-v-step="7"]',
            header: {
                title: `${that.$t("tour.visitorsTab")}`,
            },
            content: `${that.$t("tour.visitorsTabContent")}`,
            params: {
                placement: "left",
            },
        },
        {
            target: '[data-v-step="8"]',
            header: {
                title: `${that.$t("tour.visitorTabHistory")}`,
            },
            content: `${that.$t("tour.visitorTabHistoryContent")}`,
            params: {
                placement: "left",
            },
        },
        {
            target: '[data-v-step="9"]',
            header: {
                title: `${that.$t("tour.representativeTab")}`,
            },
            content: `${that.$t("tour.representativeTabContent")}`,
            params: {
                placement: "left",
            },
        },
        {
            target: '[data-v-step="10"]',
            header: {
                title: `${that.$t("tour.liveSupport")}`,
            },
            content: `${that.$t("tour.liveSupportContent")}`,
            params: {
                placement: "right",
            },
        },
        {
            target: '[data-v-step="11"]',
            header: {
                title: `${that.$t("tour.siteVisitors")}`,
            },
            content: `${that.$t("tour.siteVisitorsContent")}`,
            params: {
                placement: "right",
            },
        },
        {
            target: '[data-v-step="12"]',
            header: {
                title: `${that.$t("tour.tableSettings")}`,
            },
            content: `${that.$t("tour.tableSettingsContent")}`,
            params: {
                placement: "right",
            },
        },
        {
            target: '[data-v-step="13"]',
            header: {
                title: `${that.$t("tour.watchModeButton")}`,
            },
            content: `${that.$t("tour.watchModeContent")}`,
            params: {
                placement: "right",
            },
        },
        {
            target: '[data-v-step="14"]',
            header: {
                title: `${that.$t("tour.popoverInfo")}`,
            },
            content: `${that.$t("tour.popoverInfoContent")}`,
            params: {
                placement: "right",
            },
        },
        {
            target: '[data-v-step="15"]',
            header: {
                title: `${that.$t("tour.popoverButton")}`,
            },
            content: `${that.$t("tour.popoverButtonContent")}`,
            params: {
                placement: "right",
            },
        },
        {
            target: '[data-v-step="16"]',
            header: {
                title: `${that.$t("tour.openChat")}`,
            },
            content: `${that.$t("tour.openChatContent")}`,
            params: {
                placement: "right",
            },
        },
        /*        {
                    target: '[data-v-step="17"]',
                    header: {
                        title: `${that.$t('tour.pagination')}`,
                    },
                    content: `${that.$t('tour.paginationContent')}`,
                    params: {
                        placement: 'right'
                    }
                },*/
        {
            target: '[data-v-step="17"]',
            header: {
                title: `${that.$t("tour.chatwindow.chatWindowActionButtons")}`,
            },
            content: `${that.$t("tour.chatwindow.settingsButton")}`,
            params: {
                placement: "right",
            },
        },
        {
            target: '[data-v-step="18"]',
            header: {
                title: `${that.$t("tour.chatwindow.chatWindowActionButtons")}`,
            },
            content: `${that.$t("tour.chatwindow.hideButton")}`,
            params: {
                placement: "bottom",
            },
        },
        {
            target: '[data-v-step="19"]',
            header: {
                title: `${that.$t("tour.chatwindow.chatWindowActionButtons")}`,
            },
            content: `${that.$t("tour.chatwindow.closeButton")}`,
            params: {
                placement: "bottom",
            },
        },
        {
            target: '[data-v-step="20"]',
            header: {
                title: `${that.$t("tour.chatwindow.otherPanels")}`,
            },
            content: `${that.$t("tour.chatwindow.preparedContentWidget")}`,
            params: {
                placement: "bottom",
            },
        },
        {
            target: '[data-v-step="21"]',
            header: {
                title: `${that.$t("tour.chatwindow.otherPanels")}`,
            },
            content: `${that.$t("tour.chatwindow.userInfoWidget")}`,
            params: {
                placement: "bottom",
            },
        },
        {
            target: '[data-v-step="22"]',
            header: {
                title: `${that.$t("tour.chatwindow.otherPanels")}`,
            },
            content: `${that.$t("tour.chatwindow.chatBarButton")}`,
            params: {
                placement: "left",
            },
        },
    ];
    return steps;
};
